export default class DateFormatter {
  static formatDate(dateString, optionString = "en-US") {
    return new Date(dateString).toLocaleDateString(optionString);
  }
}

window.PS.Models.DateFormatter = DateFormatter;
